import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { FsaAuthorizationNumberExisted } from '../../Models/Models/Company/FsaAuthorizationNumberExisted';

declare var IS_RUNNING_IN_APP_POOL;

export class FsaAuthorizationNumberCheckClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(fsaAuthorizationNumber: string): Promise<FsaAuthorizationNumberExisted, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Company/FsaAuthorizationNumberCheck/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { fsaAuthorizationNumber: fsaAuthorizationNumber }

    return AjaxWrapper.get<FsaAuthorizationNumberExisted, any>(url, data);
  }
}

